<template>
  <div>
    <el-form :model="form" size="mini" :inline="true">
      <el-form-item label="包件编码">
        <el-input v-model.trim="form.packCode"></el-input>
      </el-form-item>
      <el-form-item label="包件名称">
        <el-input v-model.trim="form.packName"></el-input>
      </el-form-item>
      <!-- <el-form-item label="销售定位">
        <sale-select v-model="form.saleLocation" :all="true"></sale-select>
      </el-form-item> -->
      <el-form-item label="店铺名称" v-if="isAllPlan">
        <el-select v-model="form.storeId" placeholder="请选择">
          <el-option
            v-for="item in authOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预估情况" v-if="statusVisible">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in statusOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button type="warning" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import saleSelect from '@/views/preSalePlan/common/saleSelect'
import storeSelect from '@/views/preSalePlan/common/storeSelect'

import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  props: ['formData'],
  components: { saleSelect, storeSelect },
  data() {
    return {
      form: {
        // saleLocation: ''
      },
      statusOptions:[
        { id: '', name: '全部'},
        { id: '积压', name: '积压'},
        { id: '超卖', name: '超卖'},
        { id: '正常', name: '正常'},
      ]
    }
  },
  computed: {
    // 预估情况 显示/隐藏
    statusVisible() {
      return this.isReported;
    }
  },
  watch: {
    statusVisible: {
      handler (val) {
        val && this.$set(this.form, 'status', '')
      },
      immediate: true
    }
  },
  methods: {
    search() {
      this.$emit('search', this.form)
    },
    reset() {
      if(!this.statusVisible) {
        this.form = {
          // saleLocation: '',
        };
      }else{
        this.form = {
          // saleLocation: '',
          status: ''
        };
      }
      this.$nextTick(_=>{
        this.$emit('search',null,1)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-form-item--mini.el-form-item, >>> .el-form-item--small.el-form-item
    margin-bottom 0

  >>> .el-input, >>> .el-select
    width 110px !important
</style>